module.exports = __webpack_public_path__ + "static/media/31JFA9.b2adbc1f.jpg";